/* ==========================================================================
   AJ FITS — Collection filtering
   AJAX facet updates with history support, mobile filter drawer,
   sort handling and "view more" facet expansion.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function init(root) {
    var collection = $('[data-aj-collection]', root) || $('[data-aj-collection]');
    if (!collection || collection.dataset.ajCollectionReady) return;
    collection.dataset.ajCollectionReady = '1';

    var form = $('[data-aj-facet-form]', collection);
    var sort = $('[data-aj-sort]', collection);
    var panel = $('[data-aj-facets]', collection);
    var overlay = $('[data-aj-facets-close].aj-facets__overlay', collection) || $('.aj-facets__overlay', collection);
    var inFlight = null;

    /* ---- Mobile drawer ------------------------------------------------ */
    function openFilters() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        setTimeout(function () { overlay.hidden = true; }, 300);
      }
      document.body.style.overflow = '';
    }

    $$('[data-aj-facets-open]', collection).forEach(function (b) { b.addEventListener('click', openFilters); });
    $$('[data-aj-facets-close]', collection).forEach(function (b) { b.addEventListener('click', closeFilters); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) closeFilters();
    });

    /* ---- "View more" -------------------------------------------------- */
    $$('[data-aj-facet-more]', collection).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.closest('.aj-facet');
        if (facet) facet.classList.toggle('is-expanded');
      });
    });

    /* ---- Fetching ----------------------------------------------------- */
    function buildUrl() {
      var params = new URLSearchParams();

      if (form) {
        // Checkboxes and text inputs that carry a value
        $$('input, select', form).forEach(function (input) {
          if (!input.name) return;
          if (input.type === 'checkbox') {
            if (input.checked) params.append(input.name, input.value);
          } else if (input.value !== '') {
            params.append(input.name, input.value);
          }
        });
      }

      if (sort && sort.value) {
        params.delete('sort_by');
        params.append('sort_by', sort.value);
      }

      var base = window.location.pathname;
      var qs = params.toString();
      return qs ? base + '?' + qs : base;
    }

    function render(url, pushState) {
      collection.classList.add('is-loading');

      if (inFlight) inFlight.abort();
      inFlight = typeof AbortController !== 'undefined' ? new AbortController() : null;

      fetch(url, {
        signal: inFlight ? inFlight.signal : undefined,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Filter request failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Swap the results grid
          var freshResults = doc.querySelector('[data-aj-results]');
          var currentResults = $('[data-aj-results]', collection);
          if (freshResults && currentResults) currentResults.innerHTML = freshResults.innerHTML;

          // Swap the facets so counts and disabled states stay accurate
          var freshFacets = doc.querySelector('[data-aj-facets] [data-aj-facet-form]');
          var currentFacets = $('[data-aj-facet-form]', collection);
          if (freshFacets && currentFacets) {
            currentFacets.innerHTML = freshFacets.innerHTML;
            rebind();
          }

          // Swap the count, chips and size bar
          swap(doc, '[data-aj-result-count]');
          swap(doc, '[data-aj-active-filters]', '[data-aj-results]');
          swap(doc, '.aj-sizebar', '.aj-collection__layout');

          if (pushState) {
            window.history.pushState({ ajUrl: url }, '', url);
          }

          if (window.AJ && window.AJ.refresh) window.AJ.refresh(collection);

          // Bring the shopper back to the top of the results, not the page
          var main = $('.aj-collection__main', collection);
          if (main && window.scrollY > main.offsetTop) {
            window.scrollTo({ top: main.offsetTop - 120, behavior: 'smooth' });
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          // A hard navigation always beats a stuck spinner
          window.location.href = url;
        })
        .finally(function () {
          collection.classList.remove('is-loading');
        });
    }

    /*
      Swap a region in place. When the region only exists in the new document
      (active-filter chips appearing for the first time) it is inserted at the
      right spot instead of being silently dropped.
    */
    function swap(doc, selector, anchorSelector) {
      var fresh = doc.querySelector(selector);
      var current = $(selector, collection);

      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        current.hidden = false;
        return;
      }
      if (!fresh && current) {
        current.innerHTML = '';
        current.hidden = true;
        return;
      }
      if (fresh && !current && anchorSelector) {
        var anchor = $(anchorSelector, collection);
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(fresh.cloneNode(true), anchor);
        }
      }
    }

    /* ---- Bindings ----------------------------------------------------- */
    var onChange = debounce(function () { render(buildUrl(), true); }, 260);

    /*
      Everything is delegated from the collection root and bound exactly once.
      Re-binding per render was stacking a fresh listener on the form each
      time, so one checkbox click fired several overlapping requests.
    */
    function rebind() {
      var currentForm = $('[data-aj-facet-form]', collection);
      if (!currentForm) return;
      // Accordions and reveals still need wiring on the injected markup
      if (window.AJ && window.AJ.refresh) window.AJ.refresh(currentForm);
    }

    collection.addEventListener('change', function (e) {
      if (e.target.closest('[data-aj-facet-form]')) { onChange(); return; }
      if (e.target.closest('[data-aj-sort]')) { render(buildUrl(), true); }
    });

    collection.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-aj-facet-form]')) return;
      e.preventDefault();
      render(buildUrl(), true);
    });

    collection.addEventListener('click', function (e) {
      // "View more" inside a facet group
      var more = e.target.closest('[data-aj-facet-more]');
      if (more) {
        var facet = more.closest('.aj-facet');
        if (facet) facet.classList.toggle('is-expanded');
        return;
      }
      // Chips, size bar and clear-all filter without a full page load
      var link = e.target.closest('[data-aj-facet-link]');
      if (link) {
        e.preventDefault();

        /* The size bar is single-select: picking L must drop M rather than
           stack both. Shopify's url_to_add always appends, so rebuild the
           query ourselves — strip every value of the size param, then add
           back just this one (unless it was already the active choice). */
        var chip = e.target.closest('[data-aj-size-chip]');
        if (chip && chip.dataset.sizeParam) {
          var url = new URL(link.href, window.location.origin);
          var param = chip.dataset.sizeParam;
          var value = chip.dataset.sizeValue;
          var wasActive = chip.getAttribute('aria-pressed') === 'true';

          url.searchParams.delete(param);
          if (!wasActive) url.searchParams.append(param, value);
          url.searchParams.delete('page');

          render(url.toString(), true);
          return;
        }

        render(link.href, true);
      }
    });

    if (form) rebind();

    window.addEventListener('popstate', function () {
      render(window.location.href, false);
    });
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
